export default __webpack_public_path__ + "static/media/Portfolio.83b272eb.jpg";